import { Typography } from '@mui/material';
import { FormSection, RadioButtons } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { IndexContext } from '../CaseContext';
import { WhatDidDoDuringAccident } from './WhatDidDoDuringAccident';
import { LicenseAndInvolved } from './LicenseAndInvolved';
import { Insurance } from './Insurance';
import { PoliceReport } from './PoliceReport';
import { yesNoOptions } from 'Constants';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';

export const ThirdSection = () => {
  const { index } = useContext(IndexContext);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const caseTypeSection = useWatch({
    name: `${baseName}.caseTypeSection`,
  });

  const isCarAccident = useWatch({
    name: `${baseName}.isTrafficAccident`,
    defaultValue: false,
  }) as boolean;

  if (!caseTypeSection?.isInjury && !caseTypeSection?.isPostTrauma) return null;

  return (
    <FormSectionWrapper>
      <FormSection grouped id={dictionary.thirdSectionTitle}>
        <Typography
          fontSize={isDesktop ? '18px !important' : '16px !important'}
          sx={{ fontWeight: 'bold' }}
        >
          {dictionary.thirdSectionTitle}
        </Typography>
        <RadioButtons
          id={dictionary.thirdSectionFirstToggleButtonLabel}
          name={`${baseName}.isTrafficAccident` as const}
          options={yesNoOptions}
        />
        {isCarAccident && (
          <>
            <WhatDidDoDuringAccident />
            <LicenseAndInvolved />
            <Insurance />
            <PoliceReport />
          </>
        )}
      </FormSection>
    </FormSectionWrapper>
  );
};
